import {Grid} from "@mui/material";
import Box from "@mui/material/Box";
import useEmergencyInterventionDocumentRepository
    from "../../../../../repository/b2csdu/useEmergencyInterventionDocumentRepository";
import {useEffect} from "react";
import isNull from "../../../../../mixin/isNull";
import SlideFile from "../../../../../material/file/SlideFileCustom";
import FileData from "../../../../../material/file/FileData";
import Typography from "@mui/material/Typography";

export default function ({orderDocumentId}) {
    const emergencyInterventionDocumentRepository = useEmergencyInterventionDocumentRepository();
    /** @type EmergencyInterventionDocument */
    const emergencyInterventionDocument = emergencyInterventionDocumentRepository.findOneById(orderDocumentId).select();

    useEffect(() => {
        if (isNull(orderDocumentId)) return;

        emergencyInterventionDocumentRepository.findOneById(orderDocumentId).exec();
    }, []);

    const getFile = async id => {
        const file = await emergencyInterventionDocumentRepository.getFile(emergencyInterventionDocument.getId(), id);

        return new FileData(file.name, file.base64, file.content_type);
    }

    if (isNull(emergencyInterventionDocument)) {
        return (
            <Box mt={10} textAlign={"center"}>
                <Typography variant="h6" color="textSecondary">Aucune photo disponible</Typography>
            </Box>
        )
    }

    return (
        <Grid item xs={12} mt={5}>
            <Box>
                {
                    emergencyInterventionDocument.getPictureBeforeIds().length > 0
                        ? (
                            <Box>
                                <Typography component="div" sx={{flexGrow: 1}}>
                                    Photos avant intervention
                                </Typography>
                                <Box mt={3}>
                                    <SlideFile
                                        key={emergencyInterventionDocument.getPictureBeforeIds()}
                                        ids={emergencyInterventionDocument.getPictureBeforeIds()}
                                        getFile={getFile}
                                        disableDownload={true}
                                    />
                                </Box>
                            </Box>
                        )
                        : null
                }
                {
                    emergencyInterventionDocument.getPictureAfterIds().length > 0
                        ? (
                            <Box mt={6}>
                                <Typography component="div" sx={{flexGrow: 1}}>
                                    Photos après intervention
                                </Typography>
                                <Box mt={3}>
                                    <SlideFile
                                        key={emergencyInterventionDocument.getPictureAfterIds()}
                                        ids={emergencyInterventionDocument.getPictureAfterIds()}
                                        getFile={getFile}
                                        disableDownload={true}
                                    />
                                </Box>
                            </Box>
                        )
                        : null
                }
            </Box>
        </Grid>
    )
}